/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React from 'react';
import {Icon} from "./controls";

export const Div = (props) => {
    const { className, children, scrollable } = props;
    return (
        <div className={className}>
            {children}
        </div>
    );
};

export const TitledPanel = (props) => {
    const { children,text,icon, onEditClick ,label} = props;
    return (
        <div>
            <div className="panel-heading block-heading">
                {icon &&
                    <Icon name={icon} />
                }
                <h4 className="panel-title">{text}</h4>
            </div>
            {onEditClick && <Icon name="edit" size="small" onClick={onEditClick} label={`${label} ${text}`}/>}
            {children}
        </div>
    );
};

